import { parseFilters, getConfigName } from 'App/helpers/filterHelper';
import { isInactiveValue } from 'App/helpers/filterHelperInstances';
import _ from 'lodash';
import contactFilters from 'App/babel/filterConfigs/Contact';
const ContactFilters = contactFilters();

const MergeFilters = (
	filters,
	getConfig = fc => (ContactFilters[fc] ? { ...ContactFilters[fc], filterName: fc } : null)
) => {
	filters = filters || [];
	return filters.reduce((res, filterObj) => {
		var activeConfigs = _.pick(filterObj.config, (filter, filterName) => {
			const configName = getConfigName(filterName);
			const fc = getConfig ? getConfig(configName) : null;
			return !isInactiveValue(filter, 'contact', fc);
		});

		if (Object.keys(activeConfigs).length) {
			const build = parseFilters(activeConfigs, 'contact', null, null, {
				getConfig,
				useTags: true,
				groupAllFilters: true
			}).build();
			const body = { q: build.q || [] };

			if (build.customerId) {
				body.customerId = build.customerId;
			}
			if (build.userId) {
				body.userId = build.userId;
			}

			res.push({ ...filterObj, config: activeConfigs, body: body });
		}
		return res;
	}, []);
};

export default MergeFilters;
